import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import BADGES, { BADGES_LANGUAGES } from 'modules/badges/badgesData';
import useTranslation from 'shared/hooks/useTranslation';

type BadgeProps = {
  active: boolean;
};

type BadgeBarProps = {
  handleBadge: (id: number) => void;
  currentBadge: number;
};

const BadgesBarWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.MEDIA.MD} {
    height: max-width;
    width: 10rem;
    position: absolute;
    top: 0;
    gap: 1rem;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 8rem 0 10rem 0;
    z-index: 100;

    @media (-webkit-min-device-pixel-ratio: 1.25) {
      height: max-content;
      top: -10%;
      align-items: flex-start;
    }
  }
`;

const Badge = styled.div<BadgeProps>`
  filter: ${({ active }) => (active ? 'none' : 'grayscale(1)')};
  transition:
    filter 0.3s ease-in-out,
    transform 0.4s ease-in-out;
  transform: ${({ active }) => (active ? 'scale(1.3)' : 'scale(1)')};

  &:hover {
    transform: scale(1.3);
    cursor: pointer;
    filter: none;
  }

  @media (-webkit-min-device-pixel-ratio: 1.25) {
    transform: ${({ active }) => (active ? 'scale(.9)' : 'scale(.6)')};
  }
`;

export default function BadgesBar({ handleBadge, currentBadge }: BadgeBarProps): JSX.Element {
  const { lang } = useTranslation('badgesPage');

  return (
    <BadgesBarWrapper>
      {BADGES.map((badge) => (
        <Badge key={badge.id} active={badge.id - 1 === currentBadge} onClick={() => handleBadge(badge.id - 1)}>
          <Image
            src={`/img/badges/v2/${BADGES_LANGUAGES.includes(lang) ? lang : 'en'}/${badge.src}.svg`}
            alt={badge.name}
            height={60}
            width={60}
          />
        </Badge>
      ))}
    </BadgesBarWrapper>
  );
}
